import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import useBitacoraLogic from "./hooks/useBitacoraLogic";
import BitacoraView from "./pages/BitacoraView.jsx";

export default function Bitacora({ user: initialUser = null }) {
  const [user, setUser] = useState(initialUser);
  const location = useLocation();
  const openedRef = useRef(new Set());

  useEffect(() => {
    if (initialUser) {
      setUser(initialUser);
      return;
    }
    try {
      const stored = localStorage.getItem("user");
      if (stored) {
        setUser(JSON.parse(stored));
      }
    } catch (error) {
      console.error("No fue posible recuperar el usuario desde localStorage:", error);
    }
  }, [initialUser]);

  const logic = useBitacoraLogic(user);
  const { bitacora, handleEditar } = logic;

  useEffect(() => {
    const search = location?.search || "";
    if (!search) return;
    const params = new URLSearchParams(search);
    const rawId = params.get("bitacoraId") || params.get("bitacora_id");
    const bitacoraId = rawId ? Number(rawId) : null;
    if (!bitacoraId || Number.isNaN(bitacoraId)) return;
    if (openedRef.current.has(bitacoraId)) return;
    const registro = (bitacora || []).find((item) => Number(item.id) === bitacoraId);
    if (!registro) return;
    openedRef.current.add(bitacoraId);
    handleEditar(registro);
  }, [location?.search, bitacora, handleEditar]);

  if (!user) {
    return <div className="text-center p-5">Cargando usuario...</div>;
  }

  return <BitacoraView {...logic} />;
}
